
import { useEffect } from "react";
import { useToast } from "@/components/ui/use-toast";
import { WordPair } from "@/types/game";
import { loadGameDataWithStateUpdates } from "@/utils/gameLoaderService";

/**
 * Hook to initialize game data and set up initial state
 */
export const useGameInitialization = (
  gameId: string | null,
  userId: string | null,
  setLoading: (loading: boolean) => void,
  setGameStatus: (status: string) => void,
  setGameOver: (gameOver: boolean) => void,
  setConvergenceRound: (round: number | null) => void,
  setRounds: (rounds: WordPair[]) => void,
  setUsedWords: (usedWords: Set<string>) => void,
  setIsOwner: (isOwner: boolean) => void,
  setBotHasChosenWord: (hasChosen: boolean) => void,
  generateBotWordForCurrentRound: (rounds: WordPair[]) => Promise<void>
) => {
  const { toast } = useToast();

  // Load game data from Supabase
  useEffect(() => {
    const fetchGameData = async () => {
      await loadGameDataWithStateUpdates(
        gameId,
        userId,
        toast,
        setLoading,
        setGameStatus,
        setGameOver,
        setConvergenceRound,
        setRounds,
        setUsedWords,
        setIsOwner,
        setBotHasChosenWord,
        generateBotWordForCurrentRound
      );
    };

    fetchGameData();
  }, [gameId, toast, userId]);
};
